module.exports = __webpack_public_path__ + "files/a2b620589776f1b4947eccd2a1d05c37.png";